import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=261125ae&scoped=true&"
import script from "./CCheckbox.vue?vue&type=script&lang=js&"
export * from "./CCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=261125ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261125ae",
  null
  
)

export default component.exports